module.exports = __webpack_public_path__ + "static/tcsLogo-aadafac3cb302036d5d387877c818068.png";